import { initializeApp } from 'firebase/app';
import {
  browserLocalPersistence,
  getAuth,
  RecaptchaVerifier,
  setPersistence,
  signInWithPhoneNumber,
} from 'firebase/auth';

// Preencha as variáveis REACT_APP_FIREBASE_* no .env.local
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Persiste sessão no navegador.
setPersistence(auth, browserLocalPersistence).catch(() => {});

export { RecaptchaVerifier, signInWithPhoneNumber };
